import { css } from '@microsoft/fast-element';
import { getToken } from '../../design-tokens';
import { display } from '../../foundation/display';
import { mediaSizeBehavior } from '../../utilities/media-size-observer';

export const containerStyles = css`
    ${display('block')}

    :host {
        width: 100%;
    }

    .container {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
`.withBehaviors(
    mediaSizeBehavior('small',
        css`
            .container {
                width: calc(${getToken('space-breakpoint-small')} * 1px);
            }
        `
    ),
    mediaSizeBehavior('medium',
        css`
            .container {
                width: calc(${getToken('space-breakpoint-medium')} * 1px);
            }
        `
    ),
    mediaSizeBehavior('large',
        css`
            .container {
                width: calc(${getToken('space-breakpoint-large')} * 1px);
            }
        `
    ),
    mediaSizeBehavior('extra-large',
        css`
            .container {
                width: calc(${getToken('space-breakpoint-extra-large')} * 1px);
            }
        `
    ),
);
